// extracted by mini-css-extract-plugin
export default {"container":"Footer01_container__v90Vt"};